import { IActions, IState } from "./interfaces";

import { FormState } from "./types";
import { ILanguageTranslations } from "./interfaces/languages";
import { PRODUCTS } from "./constants";
import React from "react";
import styles from "./styles";
import { useReactHookz } from "./state";

interface Props {
  form: FormState;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const CalculatorForm: React.FC<Props> = ({ form, onChange, onSubmit }) => {
  const [state]: [IState, IActions] = useReactHookz();
  const t = state.translations as ILanguageTranslations;
  return (
    <form onSubmit={onSubmit} className="purefloc-form">
      <h2 style={styles.title}>{t.title}</h2>

      {/* Product Select */}
      <div style={styles.inputField}>
        <label style={styles.inputLabel}>
          {t.productLabel} <span style={{ color: "red" }}>*</span>
        </label>
        <select
          id="product"
          value={form.product}
          onChange={onChange}
          required
          style={styles.select}
        >
          <option value="">{t.selectPlaceholder}</option>
          {Object.keys(PRODUCTS).map((p) => (
            <option key={p}>{p}</option>
          ))}
        </select>
      </div>

      {/* Application Select */}
      <div style={styles.inputField}>
        <label style={styles.inputLabel}>
          {t.applicationLabel} <span style={{ color: "red" }}>*</span>
        </label>
        <select
          id="application"
          value={form.application}
          onChange={onChange}
          required
          style={styles.select}
        >
          <option value="">{t.selectPlaceholder}</option>
          {(PRODUCTS[form.product] || []).map((a) => (
            <option key={a}>{a}</option>
          ))}
        </select>
      </div>

      {/* Surface and Thickness */}
      {["surface", "thickness"].map((field) => (
        <div style={styles.inputField} key={field}>
          <label style={styles.inputLabel}>
            {t[`${field}Label`]} <span style={{ color: "red" }}>*</span>
          </label>
          <div style={styles.inputGroup}>
            <input
              id={field}
              type="number"
              placeholder={t[`${field}LabelPlaceholder`]}
              onChange={onChange}
              value={(form as any)[field]}
              required
              style={styles.inputWithUnit}
            />
            <span style={styles.unit}>{field === "surface" ? "m²" : "mm"}</span>
          </div>
        </div>
      ))}

      <div style={styles.centerContent}>
        <button
          type="submit"
          style={styles.submitButton}
          className="purefloc-button"
        >
          {t.submitButton}
        </button>
      </div>
    </form>
  );
};

export default CalculatorForm;
